import { useServices } from "@/services-context";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { LayoutTypes, useLayoutType } from "@/util-react/layout";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense";
import { Services } from "@/services/services";
import { StaticPagesType } from "@/context/static-pages";
import { PageTags } from "@/elements-react/document-elements/page-tags";
import { Url } from "@/helpers/url";
import { SeoMarkupDataset } from "@/services/seo-markup";
import { ProductRangeDesktop } from "@/pages-react/product-range-page/ProductRangeDesktop";
import { ProductRangeMobile } from "@/pages-react/product-range-page/ProductRangeMobile";

const fetchPageData = async (params: { services: Services; location: LocationHook; route: RouteHook }) => {
  const { services, location, route } = params;

  await services.initialize.prepare({
    location: location,
    route: route,
  });

  const registryUrl = Url.normalizeRoute(route.path);
  const alternates = await services.routes.resolveAlternates(registryUrl);

  if (!services.staticPages.has(StaticPagesType.productRange)) {
    await services.staticPages.fetchStaticPage(StaticPagesType.productRange);
  }

  return {
    type: "static",
    canonical: registryUrl,
    alternates: alternates,
  };
};

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return ProductRangeDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return ProductRangeMobile;
  }
};

export const ProductRangePage = pageSuspense(() => {
  const route = useRoute();
  const location = useLocation();
  const services = useServices();
  const { layoutType } = useLayoutType();

  const seoMarkupDataset = useSuspenseLoader({
    key: "product-range-route",
    loader: () =>
      fetchPageData({
        services: services,
        location: location,
        route: route,
      }),
  }) as SeoMarkupDataset;

  const content = services.staticPages.getStaticPage(StaticPagesType.productRange);
  const PageComponent = getPageComponent(layoutType);

  return (
    <div style={{ display: "contents" }}>
      <PageComponent content={content} />
      <PageTags seo={seoMarkupDataset} />
    </div>
  );
});
